import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { DetailSection } from "./productDetailContent";

type Props = {
    sections: DetailSection[];
};

const ProductDetailAccordion = ({ sections }: Props) => {
    const [openSections, setOpenSections] = useState<string[]>([
        sections[0]?.title ?? "",
    ]);

    const [expandedText, setExpandedText] = useState<
        Record<string, boolean>
    >({});

    const toggle = (title: string) => {
        setOpenSections((prev) =>
            prev.includes(title)
                ? prev.filter((item) => item !== title)
                : [...prev, title]
        );
    };

    return (
        <div className="pd-accordion">
            {sections.map((section) => {
                const open = openSections.includes(section.title);
                const longBullets =
                    (section.bullets?.length ?? 0) > 4;

                const expanded =
                    expandedText[section.title] ?? false;

                const visibleBullets = expanded
                    ? section.bullets
                    : section.bullets?.slice(0, 4);

                return (
                    <article
                        className={`pd-accordion-item ${open ? "open" : ""
                            }`}
                        key={section.title}
                    >
                        <button
                            type="button"
                            className="pd-accordion-trigger"
                            onClick={() => toggle(section.title)}
                        >
                            <span>
                                <strong>
                                    {section.title}
                                </strong>

                                <small>
                                    {section.subtitle}
                                </small>
                            </span>

                            <ChevronDown size={19} />
                        </button>

                        {open && (
                            <div className="pd-accordion-content">
                                {section.rows?.length ? (
                                    <div className="pd-detail-list">
                                        {section.rows.map((row) => (
                                            <div
                                                className="pd-detail-row"
                                                key={`${section.title}-${row.label}`}
                                            >
                                                <span>
                                                    {row.label}
                                                </span>

                                                <strong>
                                                    {row.value}
                                                </strong>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}

                                {visibleBullets?.length ? (
                                    <ul className="pd-bullets">
                                        {visibleBullets.map(
                                            (bullet) => (
                                                <li key={bullet}>
                                                    {bullet}
                                                </li>
                                            )
                                        )}
                                    </ul>
                                ) : null}

                                {section.paragraph ? (
                                    <p className="pd-detail-paragraph">
                                        {section.paragraph}
                                    </p>
                                ) : null}

                                {longBullets && (
                                    <button
                                        type="button"
                                        className="pd-see-more"
                                        onClick={() =>
                                            setExpandedText(
                                                (prev) => ({
                                                    ...prev,
                                                    [section.title]:
                                                        !expanded,
                                                })
                                            )
                                        }
                                    >
                                        {expanded
                                            ? "Show less"
                                            : "See more"}
                                    </button>
                                )}
                            </div>
                        )}
                    </article>
                );
            })}
        </div>
    );
};

export default ProductDetailAccordion;
